/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonSlides, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-modal-preface-steps',
  templateUrl: './modal-preface-steps.component.html',
  styleUrls: ['./modal-preface-steps.component.scss']
})
export class ModalPrefaceStepsComponent implements OnInit {
  @ViewChild('slides', { static: false }) slides: IonSlides;

  /**
   * lista di step
   */
  @Input() steps: {
    figure?: string;
    message: string;
  }[] = [];

  /**
   * suggerimento per l'avvio degli step
   */
  @Input() startTip: string;

  /**
   * suggerimento per la conlusione degli step
   */
  @Input() endTip: string;

  /**
   * index step visualizzato
   */
  activeIndex = 0;

  /**
   * flag per renderizzare il componente slide
   */
  slidesVisible = false;

  /**
   * getter per determinare se gli step sono completi
   */
  get completed(): boolean {
    return this.activeIndex >= this.steps.length - 1;
  }

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    // renderizzo con timeout lo slide perchè per occupare l'intera altezza è necessario che la modale sia comparsa del tutto
    setTimeout(() => {
      this.slidesVisible = true;
    }, 50);
  }

  /**
   * evento al cambio slide
   */
  onSlideWillChange(): void {
    this.setActiveIndex();
  }

  /**
   * naviga allo step successivo
   */
  toNextStep(): void {
    this.toStep(this.activeIndex + 1);
  }

  /**
   * naviga allo step precedente
   */
  toPrevStep(): void {
    this.toStep(this.activeIndex - 1);
  }

  /**
   * naviga allo step richiesto
   */
  toStep(index: number): void {
    if (index < 0 || index > this.steps.length - 1) {
      this.close();
    } else {
      this.slides.slideTo(index);
    }
  }

  /**
   * chiude modale
   */
  private async close(): Promise<void> {
    await this.modalController.dismiss();
  }

  /**
   * imposta l'index attivo
   */
  private setActiveIndex(): void {
    this.slides.getActiveIndex().then(index => {
      this.activeIndex = index;
    });
  }
}
